<template>
  <div>
    <div class="row">
      <div v-if="!webinars || webinars.length === 0" class="d-flex flex-wrap justify-content-center align-content-center w-100" style="height: 350px">
        <img alt="empty" src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjQiIGhlaWdodD0iNDEiIHZpZXdCb3g9IjAgMCA2NCA0MSIgIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAxKSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxlbGxpcHNlIGZpbGw9IiNGNUY1RjUiIGN4PSIzMiIgY3k9IjMzIiByeD0iMzIiIHJ5PSI3Ii8+CiAgICA8ZyBmaWxsLXJ1bGU9Im5vbnplcm8iIHN0cm9rZT0iI0Q5RDlEOSI+CiAgICAgIDxwYXRoIGQ9Ik01NSAxMi43Nkw0NC44NTQgMS4yNThDNDQuMzY3LjQ3NCA0My42NTYgMCA0Mi45MDcgMEgyMS4wOTNjLS43NDkgMC0xLjQ2LjQ3NC0xLjk0NyAxLjI1N0w5IDEyLjc2MVYyMmg0NnYtOS4yNHoiLz4KICAgICAgPHBhdGggZD0iTTQxLjYxMyAxNS45MzFjMC0xLjYwNS45OTQtMi45MyAyLjIyNy0yLjkzMUg1NXYxOC4xMzdDNTUgMzMuMjYgNTMuNjggMzUgNTIuMDUgMzVoLTQwLjFDMTAuMzIgMzUgOSAzMy4yNTkgOSAzMS4xMzdWMTNoMTEuMTZjMS4yMzMgMCAyLjIyNyAxLjMyMyAyLjIyNyAyLjkyOHYuMDIyYzAgMS42MDUgMS4wMDUgMi45MDEgMi4yMzcgMi45MDFoMTQuNzUyYzEuMjMyIDAgMi4yMzctMS4zMDggMi4yMzctMi45MTN2LS4wMDd6IiBmaWxsPSIjRkFGQUZBIi8+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K">
        <div class="mt-2 w-100 text-center">Giảng viên chưa tạo webinar nào</div>
      </div>
      <div v-for="webinar in webinars" :key="webinar._id" class="col-12 col-lg-4 col-md-6">
        <!-- BEGIN Card Course o -->
        <div class="card card-course-o border-0 shadow-sm mb-3">
          <div class="card-thumb">
            <div class="bg">
              <img
                :src="webinar.thumbnail_url | getMediaUrl"
                alt=""
                style="width: 100%;height: 100%; object-fit: cover;"
              />
            </div>
          </div>
          <div class="card-body">
            <div class="item-header mb-2">
              <h5 class="item-title">
                <a href="javascript:;" @click="gotoWebinarPage(webinar.web_url)">
                  <strong>{{ webinar.name }}</strong>
                </a>
              </h5>
              <div class="item-meta small text-secondary">
                {{ getProp(webinar, 'statistics.register_count') || 0 }} người đã đăng ký
              </div>
            </div>
            <div class="item-content mb-3">
              <ul class="list-unstyled list-icons">
                <li>
                  <ion-icon name="calendar-outline" class="icon"></ion-icon>
                  <strong>{{ getTimeWebinar(webinar) }}</strong>
                </li>
                <li>
                  <ion-icon name="time-outline" class="icon"></ion-icon>
                  <strong>{{ getRangeTimeWebinar(webinar) }}</strong>
                </li>
              </ul>
            </div>
            <div
              class="border-top pt-3 mt-3 d-flex justify-content-between align-items-center"
            >
              <div>
                <button
                  class="btn btn-outline-secondary btn-sm pl-2 pr-2 mr-2"
                  @click="$emit('edit-webinar', webinar)"
                >
                  <b-icon-pencil-square />
                </button>
                <button
                  class="btn btn-outline-secondary btn-sm pl-2 pr-2"
                  @click="gotoWebinarPage(webinar.web_url)"
                >
                  <b-icon-house />
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- BEGIN Card Course o -->
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  props: {
    teacher: {
      type: Object,
      required: true
    },
    webinars: {
      type: Array,
      required: true
    }
  },
  methods: {
    getProp(obj, key) {
      return _.get(obj, key) || ''
    },
    gotoWebinarPage(webinarUrl) {
      window.open(process.env.VUE_APP_LEARN_BASE + '/hoi-thao/' + webinarUrl, '_blank')
    },
    getTimeWebinar(webinar) {
      const time = new Date(webinar.start_at)
      return `${time.getDate()} tháng ${time.getMonth()}, ${time.getFullYear()}`
    },
    getTimeUnit(t) {
      return ('0' + t.toString()).slice(-2)
    },
    getRangeTimeWebinar(webinar) {
      const start = new Date(webinar.start_at)
      const end = new Date(webinar.end_at)
      return `${this.getTimeUnit(start.getHours())}:${this.getTimeUnit(start.getMinutes())} - ${this.getTimeUnit(end.getHours())}:${this.getTimeUnit(end.getMinutes())}`
    }
  }
}
</script>

<style></style>
